import React, { useEffect } from "react";
import { connect } from "react-redux";
import {
	FacebookShareButton,
	FacebookIcon,
	FacebookMessengerShareButton,
	FacebookMessengerIcon,
	TwitterShareButton,
	TwitterIcon,
	LinkedinShareButton,
	LinkedinIcon,
	WhatsappShareButton,
	WhatsappIcon,
} from "react-share";

import cardBackground from "../../assets/images/adventcalendar/card-background.png";
import giftbox from "../../assets/images/adventcalendar/nice-gift-box.png";

function Sharing({
					 numberOfItemsOpened,
				 }) {
	const currentPageURL = "https://www.buddy.hr/advent-calendar";

	useEffect(() => {
	}, []);
	return (
		<React.Fragment>
			<div
				className="w-full py-24 px-5 md:pt-20 md:p-10 text-3xl text-center tracking-tight text-white sm:text-4xl relative">

				<img src={cardBackground} className="w-full h-full hidden md:block" />
				<div className="md:absolute md:shareBox" style={{}}>
					<div className="sm:pt-5">
						<h1 className="text-6xl md:text-4xl lg:text-6xl xl:text-8xl font-advent drop-shadow-xl text-black ">Double</h1>
						<h1 className="text-6xl md:text-4xl lg:text-3xl xl:text-6xl font-advent drop-shadow-xl text-black ">The
							Joy!</h1>
						<p className="text-lg md:text-sm lg:text-lg pb-10 md:pb-2 pt-5 md:pt-1 lg:pt-5 px-10 md:px-6 font-serif drop-shadow-xl text-black">Open,
							Share, Care: Each
							Advent Box Unlocks a Donation in Your Name
						</p>
						<img src={giftbox}
							 className="mb-10 md:mb-1 lg:mt-10 w-32 h-32 xl:w-48 xl:h-48 text-center inline-block mt-2" />

					</div>


					<div className="pt-6 lg:pt-10 p-6 w-full h-auto flex flex-wrap justify-center gap-4">
						<FacebookShareButton
							url={currentPageURL}
							hashtag="#MakingPayrollAboutPeople"
						>
							<FacebookIcon size={38} round={true} />
						</FacebookShareButton>

						<FacebookMessengerShareButton
							appId="2116278978716420"
							url={currentPageURL}
						>
							<FacebookMessengerIcon size={38} round={true} />
						</FacebookMessengerShareButton>

						<TwitterShareButton
							title="Check out this advent calendar: "
							url={currentPageURL}
						>
							<TwitterIcon size={38} round={true} />
						</TwitterShareButton>

						<LinkedinShareButton
							summary="Check out this advent calendar: "
							url={currentPageURL}
						>
							<LinkedinIcon size={38} round={true} />
						</LinkedinShareButton>

						<WhatsappShareButton
							title="Check out Buddy's advent calendar:"
							url={currentPageURL}
						>
							<WhatsappIcon size={38} round={true} />
						</WhatsappShareButton>
					</div>
					<div className="text-center text-black text-3xl font-advent xl:text-6xl">
						{numberOfItemsOpened} items donated so far!
					</div>
				</div>
			</div>
		</React.Fragment>
	);
}

const mapStateToProps = (state) => {
	return {
		numberOfItemsOpened: state.adventCalendar.numberOfItemsOpened,
	};
};

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Sharing);
